module.exports = __webpack_public_path__ + "img/full3-min.643e4375.png";